import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { CvSearchSyncStatusResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';

interface Return {
  isRecomputing: boolean;
  recompute: () => void;
}

export const useRecomputeCvSearchSyncStatus = (): Return => {
  const { cvSearchSyncStatusApi } = useApiClient();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation<CvSearchSyncStatusResponseDto, AxiosError>({
    meta: { disableSuccessAlert: true },
    mutationFn: async () => (await cvSearchSyncStatusApi.recomputeCvSearchSyncStatus()).data,
    mutationKey: [QueryKeyEnum.CV_SEARCH.SYNC_STATUS_RECOMPUTE],
    onSuccess: data => {
      queryClient.setQueryData([QueryKeyEnum.CV_SEARCH.SYNC_STATUS], data);
    },
  });

  return { isRecomputing: isPending, recompute: () => mutate() };
};
